import moment from "moment";
import React, { useEffect, useState } from "react";
import submit from "submit-form";

import { AsideFeedSkeleton } from "./skeletons/AsideFeedSkeleton";

export const LiveFeed = ({ locals }) => {
  const [feedData, setFeedData] = useState([]);
  const [pagination, setPagination] = useState(1);
  const [showMoreEnabled, setShowMoreEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const {
    programMetricsFeed,
    query: { feedLimit },
  } = locals;

  useEffect(() => {
    if (programMetricsFeed && loading) {
      setLoading(false);
    }
  }, [programMetricsFeed]);

  const increasePagination = () => {
    setPagination(pagination + 1);
  };

  const updateFeedData = (programMetricsFeed) => {
    let newFeedData = [];
    // If it's the first loading, just set the state
    if (locals.query.pagination === 1) {
      newFeedData = programMetricsFeed;

      // else concat with already existing data
    } else {
      newFeedData = [...feedData].concat(programMetricsFeed);
    }
    // we sort the data from most recent to oldest
    newFeedData.sort((a, b) => {
      const dateA = moment(a.timestamp);
      const dateB = moment(b.timestamp);
      if (dateA.isBefore(dateB)) {
        return 1;
      }
      if (dateB.isBefore(dateA)) {
        return -1;
      }
      return 0;
    });
    setFeedData(newFeedData);
  };

  useEffect(() => {
    updateFeedData(programMetricsFeed);
  }, [programMetricsFeed]);

  // Show/Hide Load more button
  useEffect(() => {
    if (programMetricsFeed?.length < feedLimit) {
      setShowMoreEnabled(false);
    } else setShowMoreEnabled(true);
  }, [programMetricsFeed]);

  useEffect(() => {
    submit("/actions/refresh", {
      method: "GET",
      body: {
        pagination,
      },
    });
  }, [pagination]);

  return (
    <div role="live-feed">
      <header>
        <span>Live Feed</span>
      </header>
      {loading ? (
        <div role="feed-skeleton-wrapper">
          <AsideFeedSkeleton locals={locals} />
        </div>
      ) : (
        <div role="activity-wrapper">
          {feedData?.map((obj) => {
            const {
              metadata: { programName },
              timestamp,
              clientName,
              _id,
            } = obj;

            return (
              <div key={_id}>
                <span>
                  {clientName} added the {programName} to their calendar
                </span>
                <span>{moment(timestamp).fromNow()}</span>
              </div>
            );
          })}
          {showMoreEnabled && (
            <button data-button-type="outline" onClick={increasePagination}>
              Load more
            </button>
          )}
        </div>
      )}
    </div>
  );
};
